export default "__VITE_ASSET__Bpi7Lc____"